import { BinaryFiles } from '@excalidraw/excalidraw/types/types';
import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { dataURLtoFile } from '../utils/imageCropUtils';
import useRouterMatch from './useRouterMatch';

export const useGameBackgroundMediaFileUpload = (tenantId: string) => {
  const { mutate: upload, error, isLoading, isSuccess } = useMutation(
    ({ files }: { files: BinaryFiles }) => {
      return Promise.all(
        Object.values(files)
          .filter(file => file.dataURL.startsWith('data:image'))
          .map(async file => {
            const data = await BackendService.instance.getUploadUrlV2({
              pathToFile: `game_files/${file.id}`,
              imageType: 'slideBackgroundImage',
              mimeType: file.mimeType,
              tenantId,
            });
            const url = data.data.url;
            const fileToUpload = dataURLtoFile(file.dataURL, file.dataURL);
            if (fileToUpload) {
              await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('PUT', url, true);
                xhr.setRequestHeader('Content-Type', fileToUpload?.type);

                xhr.onreadystatechange = function() {
                  if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                      resolve(xhr.response);
                    } else {
                      reject(xhr.response);
                    }
                  }
                };
                xhr.onerror = function(response) {
                  reject(response);
                };
                xhr.send(fileToUpload);
              });
              await BackendService.instance.markUploadSuccessfulV2(
                data.data.uploadId,
                tenantId,
              );
              return Promise.resolve();
            }
            return Promise.reject();
          }),
      );
    },
  );

  return {
    upload,
    isUploading: isLoading,
    isSuccess: isSuccess,
    error: error,
  };
};
